import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DataService } from '../../../../services/data.service';
import { ClampInputData, DiagramInfo, ManufacturerModel } from '../../models/index';
import { Router } from '@angular/router';
import { pipeSpecVersion } from 'src/app/Modules/settings/models/idms/pipe-specification.model';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
@Component({
    selector: 'app-clamp-input',
    templateUrl: './clamp-input.component.html',
    styleUrls: ['./clamp-input.component.scss'],
})
export class ClampInputComponent implements OnInit {
    @Input() isRedirect: boolean;
    @Input() malignanatTrue: boolean;
    @Input() pipeSpecVersion: pipeSpecVersion;
    @Input() enable: boolean;
    @Output() returnData: EventEmitter<ClampInputData> = new EventEmitter();
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();
    resetEventsSubject: Subject<void> = new Subject<void>();
    destroy$ = new Subject();

    tooltip_position = 'above';
    checkMisalignmentFactor: boolean;
    manufacturerId: string;
    misalignmentFactorValue: number;
    clampId: string;
    pipeSizeId: string;
    boltMaterialId: string;
    clampMaterialId: string;
    pipeScheduleId: string;
    hubMaterialId: string;
    sealRingMaterialId: string;
    boltTypeValue: string;
    sealRingId: string;
    minPipeSizeId: string;
    maxPipeSizeId: string;
    pipesizeType: number;
    clampInputData: ClampInputData;
    permitsClampAlignment: boolean;
    inputFormGroup: UntypedFormGroup;
    optionList: ManufacturerModel[];
    boltMaterialAliasId: string = '';
    flangeMaterialAliasId1: string = '';
    flangeMaterialAliasId2: string = '';
    gasketAliasId: string = '';
    constructor(
        private fb: UntypedFormBuilder,
        private dataSvc: DataService,
        private globalEmittersService: GlobalEmittersService,
        public router: Router,
        public idmsSharedService: IdmsSharedService,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.permitsClampAlignment = false;
        this.clampInputData = new ClampInputData();
        this.loadFormGroup();
        this.inputFormGroup = this.fb.group({
            clampManufacturer: [this.manufacturerId, Validators.required],
            misalignmentFactor: [this.misalignmentFactorValue],
            clampSize: [this.clampId, Validators.required],
            pipeSize: [this.pipeSizeId],
            minPipeSize: [this.minPipeSizeId],
            maxPipeSize: [this.maxPipeSizeId],
            pipeSizeType: [this.pipesizeType],
            boltMaterial: [this.boltMaterialId, Validators.required],
            clampMaterial: [this.clampMaterialId, Validators.required],
            pipeSchedule: [this.pipeScheduleId, Validators.required],
            hubMaterial: [this.hubMaterialId, Validators.required],
            sealRingMaterial: [this.sealRingMaterialId, Validators.required],
            sealRingNumber: [this.sealRingId, Validators.required],
            boltType: [this.boltTypeValue, Validators.required],
            boltMaterialAliasId: [''],
            flangeMaterialAliasId1: [''],
            flangeMaterialAliasId2: [''],
            gasketAliasId: [''],
        });
        this.inputFormGroup.markAllAsTouched();
        this.globalEmittersService.clampInputFormGroup.next(this.inputFormGroup);
        // control changes
        this.inputFormGroup
            .get('clampManufacturer')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.manufacturerId = value), this.setPrestine('clampManufacturer'), (this.pipeSizeId = null), this.emitDiagramEvent()]);

        this.inputFormGroup
            .get('misalignmentFactor')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.misalignmentFactorValue = value)]);
        this.inputFormGroup
            .get('clampSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.clampId = value), this.setPrestine('clampSize')]);
        this.inputFormGroup
            .get('pipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.pipeSizeId = value;
                if (this.pipeSizeId) {
                    this.setPrestine('pipeSize'), this.emitDiagramEvent();
                }
            });
        this.inputFormGroup
            .get('boltMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.boltMaterialId = value), this.setPrestine('boltMaterial')]);
        this.inputFormGroup
            .get('clampMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.clampMaterialId = value), this.setPrestine('clampMaterial')]);
        this.inputFormGroup
            .get('pipeSchedule')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.pipeScheduleId = value), this.setPrestine('pipeSchedule')]);
        this.inputFormGroup
            .get('hubMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.hubMaterialId = value), this.setPrestine('hubMaterial')]);
        this.inputFormGroup
            .get('sealRingMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.sealRingMaterialId = value), this.setPrestine('sealRingMaterial')]);
        this.inputFormGroup
            .get('sealRingNumber')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.sealRingId = value), this.setPrestine('sealRingNumber')]);
        this.inputFormGroup
            .get('boltType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.boltTypeValue = value)]);
        this.inputFormGroup
            ?.get('minPipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.minPipeSizeId = value), this.setPrestine('minPipeSize')]);

        this.inputFormGroup
            ?.get('maxPipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.maxPipeSizeId = value), this.setPrestine('maxPipeSize')]);

        this.inputFormGroup.setValue(this.inputFormGroup.value);
        if (this.idmsSharedService.enableConfirmWithRouter(2)) {
            // Subscribe to valueChanges and emit the form when it changes
            this.inputFormGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((formValue) => {
                this.inputConfirmClicked();
            });
        }

        // if(this.enable==true){
        //   this.inputFormGroup.disable();
        // }
        this.globalEmittersService.unitUpdated.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp) {
                this.emitDiagramEvent();
            }
        });
    }

    loadFormGroup() {
        if (this.isRedirect && this.dataSvc.calculationData != null) {
            this.clampMaterialId = this.dataSvc.calculationData.input.recordId.clampMaterialId;
            this.manufacturerId = this.dataSvc.calculationData.input.recordId.manufacturerId;
            this.misalignmentFactorValue = this.dataSvc.calculationData.input.others.misalignmentFactor;
            this.clampId = this.dataSvc.calculationData.input.recordId.clampId;
            this.pipeSizeId = this.dataSvc.calculationData.input.recordId.pipeSizeId;
            this.emitDiagramEvent();
            this.boltMaterialId = this.dataSvc.calculationData.input.recordId.boltMaterialId;

            this.pipeScheduleId = this.dataSvc.calculationData.input.recordId.pipeScheduleId;
            this.hubMaterialId = this.dataSvc.calculationData.input.recordId.hubMaterialId;

            this.sealRingMaterialId = this.dataSvc.calculationData.input.recordId.sealRingMaterialId;
            this.sealRingId = this.dataSvc.calculationData.input.recordId.sealRingId;
            this.boltTypeValue = this.dataSvc.calculationData.input.others.boltType == 1 ? 'Imperial' : 'Metric';
            this.boltMaterialAliasId = this.dataSvc.calculationData.input.recordId.boltMaterialAliasId;
            this.flangeMaterialAliasId1 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId1;
            this.flangeMaterialAliasId2 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId2;
            this.gasketAliasId = this.dataSvc.calculationData.input.recordId.gasketAliasId;
        }
        if (this.router.url == '/settings/idms' || (this.idmsSharedService.enableConfirmWithRouter(2) == true && this.pipeSpecVersion)) {
            this.clampMaterialId = this.pipeSpecVersion?.recordId?.clampMaterialId;
            this.manufacturerId = this.pipeSpecVersion?.recordId?.manufacturerId;
            this.minPipeSizeId = this.pipeSpecVersion?.minimumPipeSizeId;
            this.pipesizeType = this.pipeSpecVersion?.pipeSizeType;
            this.maxPipeSizeId = this.pipeSpecVersion?.maximumPipeSizeId;

            this.misalignmentFactorValue = this.pipeSpecVersion?.others?.misalignmentFactor;
            this.clampId = this.pipeSpecVersion?.recordId?.clampId;
            this.pipeSizeId = this.pipeSpecVersion?.recordId?.pipeSizeId;
            this.emitDiagramEvent();
            this.boltMaterialId = this.pipeSpecVersion?.recordId?.boltMaterialId;
            this.pipeScheduleId = this.pipeSpecVersion?.recordId?.pipeScheduleId;
            this.hubMaterialId = this.pipeSpecVersion?.recordId?.hubMaterialId;

            this.sealRingMaterialId = this.pipeSpecVersion?.recordId?.sealRingMaterialId;
            this.sealRingId = this.pipeSpecVersion?.recordId?.sealRingId;
            this.boltTypeValue = this.pipeSpecVersion?.others?.boltType == 1 ? 'Imperial' : 'Metric';
        }
    }

    selectedCheck(selectedValue: any) {
        // checking Selected Value and asign it
        this.checkMisalignmentFactor = selectedValue;
        this.permitsClampAlignment = selectedValue;
    }

    emitResetEventToChildren() {
        this.resetEventsSubject.next();
    }

    setPrestine(controlName: string): void {
        switch (controlName) {
            case 'clampManufacturer':
                //this.setControlPristine(this._clampManufacturerRef, 'clampManufacturer')
                this.inputFormGroup.get('clampManufacturer');

                this.inputFormGroup.get('misalignmentFactor').reset(1, { emitEvent: false });
                this.setControlPrestine('clampSize');
                this.setControlPrestine('pipeSize');
                this.setControlPrestine('clampMaterial');
                this.setControlPrestine('pipeSchedule');
                // this.setControlPrestine('hubMaterial');
                // this.setControlPrestine('sealRingMaterial');
                this.setControlPrestine('sealRingNumber');

                if (this.jointCalcService?.isPipeCode) {
                    this.setControlPrestine('boltMaterial');
                    this.setControlPrestine('hubMaterial');
                    this.setControlPrestine('sealRingMaterial');
                }
                //this.emitResetEventToChildren()
                break;
            case 'clampSize':
                this.setControlPrestine('pipeSize');
                // this.setControlPrestine('clampMaterial'); // After updating clampsize it reset clampMaterial
                this.setControlPrestine('pipeSchedule');
                // this.setControlPrestine('hubMaterial');
                // this.setControlPrestine('sealRingMaterial');
                this.setControlPrestine('sealRingNumber');

                if (this.jointCalcService.isPipeCode) {
                    this.setControlPrestine('boltMaterial');
                    this.setControlPrestine('clampMaterial');
                    this.setControlPrestine('pipeSchedule');
                    this.setControlPrestine('hubMaterial');
                    this.setControlPrestine('sealRingMaterial');
                }

                //this.emitResetEventToChildren()
                break;
            case 'pipeSize':
            case 'boltMaterial':
                // this.setControlPrestine('clampMaterial'); // After updating pipesize it reset clampMaterial
                // this.setControlPrestine('pipeSchedule'); // After updating pipesize it reset pipeSchedule
                // this.setControlPrestine('hubMaterial');
                // this.setControlPrestine('sealRingMaterial');
                this.setControlPrestine('sealRingNumber');
                //this.emitResetEventToChildren()
                if (this.jointCalcService.isPipeCode) {
                    this.setControlPrestine('clampMaterial');
                    this.setControlPrestine('pipeSchedule');
                    this.setControlPrestine('hubMaterial');
                    this.setControlPrestine('sealRingMaterial');
                }
                break;
            case 'clampMaterial':
                this.setControlPrestine('pipeSchedule');
                // this.setControlPrestine('hubMaterial');
                // this.setControlPrestine('sealRingMaterial');
                // this.setControlPrestine('sealRingNumber');
                if (this.jointCalcService.isPipeCode) {
                    this.setControlPrestine('pipeSchedule');
                    this.setControlPrestine('hubMaterial');
                    this.setControlPrestine('sealRingMaterial');
                    this.setControlPrestine('sealRingNumber');
                }

                break;
            case 'pipeSchedule':
                // this.setControlPrestine('hubMaterial'); // After updating pipeSchedule it reset hubMaterial
                // this.setControlPrestine('sealRingMaterial');
                // this.setControlPrestine('sealRingNumber');
                if (this.jointCalcService.isPipeCode) {
                    this.setControlPrestine('hubMaterial'); // After updating pipeSchedule it reset hubMaterial
                    this.setControlPrestine('sealRingMaterial');
                    this.setControlPrestine('sealRingNumber');
                }
                break;
            case 'hubMaterial':
                // this.setControlPrestine('sealRingMaterial');
                // this.setControlPrestine('sealRingNumber');
                if (this.jointCalcService.isPipeCode) {
                    this.setControlPrestine('sealRingMaterial');
                    this.setControlPrestine('sealRingNumber');
                }
                break;
            case 'sealRingNumber':
                break;
        }
    }

    private setControlPrestine(controlName: string) {
        this.inputFormGroup.get(controlName).reset('', { emitEvent: false });
    }

    inputConfirmClicked() {
        this.inputFormGroup.markAllAsTouched();
        if (this.inputFormGroup.valid) {
            this.clampInputData.manufacturerId = this.inputFormGroup.get('clampManufacturer').value;
            if (this.inputFormGroup.get('clampManufacturer').value) {
                const misalignmentValue = this.permitsClampAlignment ? this.inputFormGroup.get('misalignmentFactor').value : null;

                this.clampInputData.misalignmentFactor = misalignmentValue;
            }
            this.clampInputData.clampId = this.inputFormGroup.get('clampSize').value;
            this.clampInputData.pipeSizeId = this.inputFormGroup.get('pipeSize').value;
            this.clampInputData.boltMaterialId = this.inputFormGroup.get('boltMaterial').value;
            this.clampInputData.clampMaterialId = this.inputFormGroup.get('clampMaterial').value;
            this.clampInputData.pipeScheduleId = this.inputFormGroup.get('pipeSchedule').value;
            this.clampInputData.hubMaterialId = this.inputFormGroup.get('hubMaterial').value;
            this.clampInputData.sealRingMaterialId = this.inputFormGroup.get('sealRingMaterial').value;
            this.clampInputData.sealRingId = this.inputFormGroup.get('sealRingNumber').value;
            this.clampInputData.boltType = this.inputFormGroup.get('boltType').value;

            this.clampInputData.boltMaterialAliasId = this.inputFormGroup.get('boltMaterialAliasId')?.value;
            this.clampInputData.flangeMaterialAliasId1 = this.inputFormGroup.get('flangeMaterialAliasId1')?.value;
            this.clampInputData.flangeMaterialAliasId2 = this.inputFormGroup.get('flangeMaterialAliasId2')?.value;
            this.clampInputData.gasketAliasId = this.inputFormGroup.get('gasketAliasId')?.value;

            this.clampInputData.isDataValid = true;
            this.returnData.emit(this.clampInputData);
        } else {
            this.clampInputData.isDataValid = false;
        }
    }

    emitDiagramEvent() {
        let diagramInfo = new DiagramInfo();
        //diagramInfo.diagramId = 'a71ff2b6-1ad1-419c-837b-0ff1ce401809'
        diagramInfo.name = 'Clamp';
        diagramInfo.clampId = this.clampId;
        diagramInfo.diagramType = 'Clamp';
        diagramInfo.pipesizeId = this.pipeSizeId;
        this.diagram.emit(diagramInfo);
    }
}
